import { useState } from "react"

export const useDrawerHooks = () => {
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    const onOpenDrawer = () => {
        setOpenDrawer(true)
    };
    const onCloseDrawer = () => {
        setOpenDrawer(false)
    };

    return {
       openDrawer,
       onOpenDrawer,
       onCloseDrawer
    }
}